module.exports = "https://cdn.hellotech.com/client-assets/premium-password_f7e2b7cf693d2b43cd69928111fae53d.svg";